// extracted by mini-css-extract-plugin
module.exports = {"background":"ContextMenu_background__m1JH1","menu":"ContextMenu_menu__mOOzT"};